'use client';

import Link from 'next/link';
import { SvgLoader } from '@/app/elements/svg/loader';
import { ROUTES } from '@/utils/constants';
import { useInfluencerVideoSelected } from '@/hooks/use-influencer-video-selected';
import type { GameplaySession } from '@/types/zones/slices/influencer-page-entry-point';
import './styles/default.scss';

type InfluencerPageEntryPointTileProps = {
    session: GameplaySession;
    position: number;
};

export const InfluencerPageEntryPointTile: React.FC<InfluencerPageEntryPointTileProps> = ({ session, position }) => {
    const { data } = session;
    const posterUrl = data.thumbnail ?? null;
    const profileName = data.profile?.data?.name ?? null;
    const gameplaySessionPageUid = data.gameplay_session_page?.uid;
    const { containerRef, handleVideoSelected } = useInfluencerVideoSelected<HTMLAnchorElement>({
        module: 'video_tile_zone',
        position,
        videoTitle: data.title ?? '',
        pageName: 'home'
    });

    const href = `${ROUTES.GAMEPLAY_SESSION}${gameplaySessionPageUid}`;

    return (
        <Link
            ref={containerRef}
            href={href}
            className="influencer-tile"
            data-testid="influencer-tile"
            prefetch={false}
            onNavigate={handleVideoSelected}>
            <div className="tile-poster">
                {posterUrl && <img className="tile-img" src={posterUrl} alt={data.title ?? ''} loading="lazy" />}
                <div className="tile-play" aria-hidden="true">
                    <SvgLoader iconName="play" />
                </div>
                <div className="tile-info">
                    {data.title && <p className="tile-title">{data.title}</p>}
                    {profileName && <p className="influencer-name">{profileName}</p>}
                </div>
            </div>
        </Link>
    );
};
